<app-chat-widget 
    *ngIf="customizations | async as customization" 
    [customization]="customization" 
    [projectId]="projectId"
    [widgetId]="widgetId">
</app-chat-widget>